import { addMonths, isAfter, isBefore, parseISO, startOfDay } from 'date-fns'
import { composeRules, createValidator, email, maxLength, required } from 'util/validation'
import { horarioValidator } from 'view/agenda/cadastro-agendamento/validator-agenda'
import { duracaoAgendamentoRecord } from 'view/agenda/model-agenda'

import { AgendarConsultaPanelModel } from '../components/agendar-consulta/AgendarConsultaPanel'
import {
  AgendarConsultaSectionModel,
  ComprovanteAgendamentoSectionModel,
} from '../components/agendar-consulta/model-agendarConsultaAtendimento'

export const agendarConsultaAvulsaValidator = (
  getServerTimeNow: () => Date,
  showHorarioFinal: boolean = false,
  isProximaConsulta?: boolean
) => {
  return createValidator<AgendarConsultaPanelModel>({
    avulsa: agendarConsultasValidator(getServerTimeNow, showHorarioFinal, isProximaConsulta),
    comprovante: comprovanteAgendamentoValidator,
  })
}

export const agendarConsultasValidator = (
  getServerTimeNow: () => Date,
  showHorarioFinal: boolean = false,
  isProximaConsulta?: boolean
) =>
  createValidator<AgendarConsultaSectionModel>(
    {
      observacoes: [maxLength(200)],
      ...(isProximaConsulta && {
        lotacao: [required],
      }),
    },
    (values, error) => {
      if (values?.lotacao) {
        error.data = required(values.data)
        const serverTime = getServerTimeNow()
        const dataParsed = parseISO(values?.data)

        if (isAfter(dataParsed, addMonths(serverTime, 6))) {
          error.data = 'Não é permitido agendar para datas superiores a 6 meses'
        } else if (isBefore(dataParsed, startOfDay(serverTime))) {
          error.data = 'Não é permitido agendar para datas anteriores à data atual'
        }

        if (!error.data) {
          error.horario = horarioValidator(
            showHorarioFinal,
            duracaoAgendamentoRecord.padrao.minimoEmMinutos,
            duracaoAgendamentoRecord.padrao.maximoEmMinutos
          )(values.horario ?? {})
          if (!error.horario?.inicial && values.horario?.inicial && isBefore(values.horario.inicial, serverTime))
            error.horario = { ...error.horario, inicial: 'Horário não pode ser anterior ao horário atual' }
        }
      }

      if (values?.isForaUbs) {
        error.localAtendimento = required(values.localAtendimento)
      }

      return error
    }
  )

export const comprovanteAgendamentoValidator = createValidator<ComprovanteAgendamentoSectionModel>(
  {},
  (values, error) => {
    if (values?.enviarParaCidadao) {
      error.emailCidadao = composeRules([required, email, maxLength(50)])(values.emailCidadao)
    }

    return error
  }
)
